import { get, post } from '../../helpers/api';

// HITCH-5500: the Supply-Demand Pace (SDP) admin endpoints. Plain REST under
// the admin app's global prefix, same auth (AdminGuard) as /admin/trip-throttles.
const BASE = '/admin/supply-demand-pace';

const POLICY_CHANGES_MAX_LIMIT = 200;
const READOUT_HISTORY_MAX_LIMIT = 100;

// Surface the server's message (400 validation, 409 nothing open to clear)
// instead of axios's generic "Request failed with status code ...".
const messageFrom = (e) => e?.response?.data?.message || e?.response?.data?.error || e?.message || 'Request failed';

const withQuery = (path, query) => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, String(value));
  });
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
};

const call = async (fn) => {
  try {
    const { data } = await fn();
    return data;
  } catch (e) {
    throw new Error(messageFrom(e));
  }
};

const getStatus = () => call(() => get(`${BASE}/status`));

const getState = ({ cityId, from, to } = {}) => call(() => get(withQuery(`${BASE}/state`, { cityId, from, to })));

const getGuards = ({ scope, scopeId, from, to } = {}) =>
  call(() => get(withQuery(`${BASE}/guards`, { scope, scopeId, from, to })));

const clearGuard = ({ scope, scopeId, reason }) =>
  call(() => post(`${BASE}/guards/clear`, { scope, scopeId, reason }));

const getPolicyChanges = ({ limit, from, to } = {}) =>
  call(() =>
    get(
      withQuery(`${BASE}/policy-changes`, {
        limit: limit === undefined ? undefined : Math.min(limit, POLICY_CHANGES_MAX_LIMIT),
        from,
        to,
      }),
    ),
  );

const createPolicyChange = ({ effectiveAt, description, affects }) =>
  call(() => post(`${BASE}/policy-changes`, { effectiveAt, description, affects }));

const reset = ({ reason, cityId }) => call(() => post(`${BASE}/reset`, cityId ? { reason, cityId } : { reason }));

const getReadouts = ({ windowDays } = {}) => call(() => get(withQuery(`${BASE}/readouts`, { windowDays })));

const getReadoutHistory = ({ windowDays, limit }) =>
  call(() =>
    get(
      withQuery(`${BASE}/readouts/history`, {
        windowDays,
        limit: limit === undefined ? undefined : Math.min(limit, READOUT_HISTORY_MAX_LIMIT),
      }),
    ),
  );

const supplyDemandPaceApi = {
  getStatus,
  getState,
  getGuards,
  clearGuard,
  getPolicyChanges,
  createPolicyChange,
  reset,
  getReadouts,
  getReadoutHistory,
};

export default supplyDemandPaceApi;
